import styled, { css } from 'styled-components';

interface IText {
  weight?: 'bold' | 'light' | 'regular' | 'medium' | '900' | '600';
  color?: string;
  size?: number;
  margin?: string;
  padding?: string;
  textAlign?: 'left' | 'center' | 'right';
  textDecorationLine?: 'none' | 'underline';
  textTransform?: 'none' | 'uppercase' | 'capitalize' | 'lowercase';
  flex?: number;
  condensed?: string;

  lineHeight?: number;

  p16?: boolean;
  p18?: boolean;
}

export default styled.p<IText>`
  color: ${({ theme, color }) => color || theme.colors.texts};
  font-size: ${({ size }) => `${size || 14}px`};
  font-weight: ${({ weight }) => `${weight || 'normal'}`};
  margin: ${({ margin }) => margin || '0px'};
  padding: ${({ padding }) => padding || '0px'};
  text-align: ${({ textAlign }) => textAlign || 'left'};
  text-decoration-line: ${({ textDecorationLine }) => textDecorationLine || 'none'};
  text-transform: ${({ textTransform }) => textTransform || 'none'};

  ${({ flex }) =>
    flex &&
    css`
      flex: ${flex};
    `};

  ${({ p16 }) =>
    p16 &&
    css`
      font-size: 16px;
    `};

  ${({ p18 }) =>
    p18 &&
    css`
      font-size: 18px;
    `};

  ${({ lineHeight }) =>
    lineHeight &&
    css`
      line-height: ${lineHeight}px;
    `};

  ${({ condensed, theme }) =>
    condensed &&
    css`
      font-family: ${theme.font.condensed};
    `};
`;
